import { usd } from "@moanhot/ui";
import { AdminProblem } from "@/api/adminClient";

export const when = (iso: string | null) =>
  iso === null
    ? "Never"
    : new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "UTC" }) + " UTC";

/**
 * Integer micro-USD to `$12.345` (DESIGN money format: 3 decimals). The sign
 * goes in front of the `$`, so a negative margin reads `-$1.200`.
 */
export const dollars = (micros: number) => (micros < 0 ? "-" : "") + usd(Math.abs(micros) / 1_000_000);

/**
 * Integer micro-USD as an exact editable dollar amount: at least cents, and
 * every non-zero micro digit after them, so `125000` is `0.125`, never a
 * rounded `0.13` that would read back as a different price.
 */
export function microsToInput(micros: number): string {
  const whole = Math.trunc(micros / 1_000_000);
  const frac = String(micros % 1_000_000).padStart(6, "0").replace(/0+$/, "");
  return `${whole}.${frac.padEnd(2, "0")}`;
}

/**
 * A typed dollar amount to integer micro-USD, from the digits and never
 * through a float. Null when it is not a plain amount with at most six
 * decimals.
 */
export function inputToMicros(text: string): number | null {
  const m = /^(\d{1,7})(?:\.(\d{1,6}))?$/.exec(text.trim());
  if (!m) return null;
  const [, whole, frac = ""] = m as unknown as [string, string, string | undefined];
  return Number(whole) * 1_000_000 + Number(frac.padEnd(6, "0"));
}

export const pct = (value: number | null) => (value === null ? "No spend" : `${value.toFixed(1)}%`);

export function problemText(err: unknown, fallback: string): string {
  if (!(err instanceof AdminProblem)) return fallback;
  return `${err.detail}${err.requestId ? ` Request ${err.requestId}.` : ""}`;
}

export const TH = "py-2 pr-4 font-normal";
export const TD = "py-2 pr-4";
export const NUM = "py-2 pr-4 text-right font-mono tabular-nums";
export const FIELD = "w-full rounded-sm border border-line-strong bg-raised px-2.5 py-2 text-sm text-ink placeholder:text-ink-3 focus-visible:border-focus focus-visible:outline-none";

